<template>
	<div id="home">
		<div id="header" class="row-center">
			<div class="row-center left">
				<div class="logo row-center">
					<img src="../assets/img/ebs.png" alt="logo"/>
					<span>e博视</span>
				</div>
				<nav-bar></nav-bar>
			</div>
			<div class="right row-center">
				<div ref="container">
					<Usernum :drawVisible="drawVisible"></Usernum>
					<div class="home-notifycation" @click.stop="openNotifycation">
						<el-badge is-dot :hidden="total === 0" class="accident-item-badge"
						          v-if="$store.state.project.Radio.proId==1">
							消息提醒
						</el-badge>
					</div>
				</div>
				<div class="user row-center">
					<PersonalDetails></PersonalDetails>
				</div>
			</div>
		</div>
		<div id="body" class="row-center">
			<div id="nav">
				<nav-menu></nav-menu>
			</div>
			<div style="height: 100%;overflow: hidden">
				<!-- <div class="row-center comparison-head" v-if="$route.params.name == 'Comparison'">
					<div @click="checkurl('none')"  :class="uid=='none'?'active name':'name'">回路对比</div>
					<div @click="checkurl('two')" :class="uid=='two'?'active name':'name'">时段对比</div>
                </div> -->
				<div id="content" :style="$route.params.name == 'Comparison' ? 'padding-top: 76px' : ''">
					<router-view/>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import NavMenu from "../components/home/NavMenu";
	import NavBar from "../components/home/NavBar";
	import Usernum from "./PersonalCenter/AccidentNotifycation";
	import PersonalDetails from "./PersonalCenter/PersonalDetails";
	import proto from "../components/proto";

	export default {
		name: "Home",
		data() {
			return {
				drawVisible: false,
			};
		},
		methods: {
			handle(e) {
				let tree = this.$refs.container
				if (tree) {
					if (!tree.contains(e.target)) {
						// this.showList = false
						this.drawVisible = false
					}
				}
			},
			openNotifycation: function () {
				this.drawVisible = !this.drawVisible;
			},

			closeDraw: function () {
				this.drawVisible = false;
			},
			websocketConnect: function () {
				//let ws = new WebSocket('ws://192.168.33.188:37087/ebox/life');
				let ws = new WebSocket("wss://local.vrmaker.vip:1443/api_ws/ebox/life");
				ws.binaryType = "arraybuffer";
				ws.onmessage = (res) => {
					let uint8Array = new Uint8Array(res.data);
					let messageBody = proto.MessageBody.decode(uint8Array);
					if (messageBody.dataType === 3) {
						let json = {};
						try {
							json = JSON.parse(messageBody.alarmEvent.jsonData);
							if (json.projectId !== this.projectId) {
								return;
							}
						} catch (error) {
							console.error("JSON parse fail");
						}
						let newNotifycation = {
							alarm_event_type: json.eventType,
							id: json.alarmId,
							start_time: json.startTime,
							loop_name: json.loopName,
							device_name: json.deviceName,
							alarm_type_desc: json.desc,
							read_check: false,
						};
						this.$store.commit("appendData", newNotifycation);
					} else if (messageBody.dataType === 2) {
						// console.log(messageBody.eBoxInfoList.eBoxInfos)
						this.$store.commit("setEBoxInfo", messageBody.eBoxInfoList.eBoxInfos);
					}
				};
			},
		},
		components: {
			NavMenu,
			NavBar,
			Usernum,
			PersonalDetails,
		},
		watch: {
			$route(to,from){
				
			},
			tagAndRoute() {
				document.body.id = this.$route.params.name + "-" + this.$route.params.tag;
			}
		},
		mounted() {
			document.body.id = this.$route.params.name + "-" + this.$route.params.tag;
			// console.log(this.$store.state.project.Radio.proId)
			// 加载消息提醒数据
			this.$store.dispatch("setNotifycationData");
			this.$store.dispatch("setlatest");
			this.$store.commit("resetPage");
			this.websocketConnect();
			// let a = 1000;
			// setInterval(() => {
			//   let jsonData = JSON.stringify({"loopName": a++, "eventType": "TELEMETRY_OVERRUN", "type": "异常",
			//     "deviceName": "亏点贵", "alarmId": a++, "startTime": '2021/3/23', "desc": "母线温度"});
			//   this.$store.commit('appendData', jsonData);
			// }, 2000);
			document.addEventListener('mouseup', this.handle)
			
		},
		beforeDestroy() {
			document.removeEventListener('mouseup', this.handle)
		},
		computed: {
			tagAndRoute() {
				return [this.$route.params.name, this.$route.params.tag];
			},
			total() {
				return this.$store.getters.total;
			},
			projectId() {
				return this.$store.getters.projectId;
			},
		},
	};
</script>

<style scoped lang="less">
	#home {
		width: 100%;
		height: 100%;
	}

    .comparison-head {
        font-weight: bold;
        color: #333333;
        padding: 0 24px;
        justify-content: flex-start;
        background: #ffffff;
        margin:1px 3px;
        height: 56px;


        .name {
            margin-right: 57px;
            height: 100%;
            font-size: 24rem;
            line-height: 56px;
            cursor: pointer;
			display: inline-block;
			color: #333;
			text-decoration: none;
            &.active {
                border-bottom: 2px solid rgba(13, 148, 255, 1);
                color: rgba(13, 148, 255, 1);
            }
        }
    }

	#header {
		padding: 12rem 0;
		.h(64);
		background-color: #fff;

		> div {
			width: 50%;
		}

		.left {
			justify-content: flex-start;
		}

		.right {
			justify-content: flex-end;
			padding-right: 24rem;
			border-radius: 50%;

			// }
			span {
				font-size: 18rem;
				color: #666666;
			}
		}

		.logo {
			.w(272);
			height: 100%;
			border-right: 1rem solid #e5e5e5;
			margin-right: 23rem;

			img {
				width: 28rem;
				height: 32rem;
			}

			span {
				font-size: 24rem;
				font-weight: bold;
				color: #333333;
				margin-left: 11rem;
			}
		}
	}

	#body {
		.h(1016);

		#nav {
			.w(272);
			height: 100%;
			background-color: #fff;
		}

		#content {
			.w(1648);
			height: 100%;
			background: none;
			overflow: hidden;
			padding: 24rem;
			position: relative;
		}
	}

	.home-notifycation {
		font-size: 18rem;
		font-weight: 400;
		color: #666666;
		cursor: pointer;
	}

	.user {
		font-size: 18rem;
		font-weight: 400;
		color: #666666;
		border-radius: 50% !important;

		img {
			width: 100%;
			height: 100%;
			border-radius: 50% !important;
		}
	}

	.accident-item-badge {
		margin-top: -7rem;
	}
</style>
